import { render, staticRenderFns } from "./SerCortes.vue?vue&type=template&id=7d4e57c8&scoped=true&"
import script from "./SerCortes.vue?vue&type=script&lang=js&"
export * from "./SerCortes.vue?vue&type=script&lang=js&"
import style0 from "./SerCortes.vue?vue&type=style&index=0&id=7d4e57c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e57c8",
  null
  
)

export default component.exports